module.exports = __webpack_public_path__ + "img/inktober_2020_12_slippery.31ab2543.jpg";